// extracted by mini-css-extract-plugin
export var banner = "_gx-0";
export var closeButton = "_gx-2";
export var greenCheckmark = "_gx-3";
export var hereLink = "_gx-4";
export var titleIcon = "_gx-1";